import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefresh = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ic_24/Refresh",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8.0665 10.1153V8.23057H5.32424C6.6247 5.97833 9.05598 4.46113 11.8359 4.46113C15.3415 4.46113 18.2911 6.87357 19.1298 10.1153H21.071C20.1947 5.81813 16.397 2.57642 11.8359 2.57642C8.75443 2.57642 6.01216 4.06534 4.29707 6.35527V4.46113H2.41235V10.1153H8.0665Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M15.6054 13.8847V15.7694H18.3476C17.0472 18.0217 14.6159 19.5389 11.8359 19.5389C8.33037 19.5389 5.38079 17.1264 4.54209 13.8847H2.60083C3.47722 18.1819 7.27493 21.4236 11.8359 21.4236C14.9175 21.4236 17.6597 19.9346 19.3748 17.6447V19.5389H21.2595V13.8847H15.6054Z",
			fill: "white"
		})]
	})
});
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
